export default "__VITE_ASSET__WBVU_3Pk__"